import { CommonModule, formatDate } from '@angular/common';
import { Component, inject, input, OnChanges, OnInit, signal, SimpleChanges, viewChild } from '@angular/core';
import { ModalEmploymentComponent } from './modal-employment/modal-employment.component';
import { ResumeEmployment } from 'src/app/models/resume/resume';
import Swal from 'sweetalert2';
import { ResumeService } from 'src/app/services/resume.service';

@Component({
  selector: 'app-cv-employments',
  imports: [CommonModule, ModalEmploymentComponent],
  templateUrl: './cv-employments.component.html',
  styleUrl: './cv-employments.component.css'
})
export class CvEmploymentsComponent implements OnChanges {
  public resumeId = input<number | null>(null);
  employments = signal<ResumeEmployment[]>([]);

  private readonly resumeService = inject(ResumeService);

  indexResume = signal<number | null>(null);

  modalEmploymentComponent = viewChild(ModalEmploymentComponent);

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['resumeId']?.currentValue) {
      this.getResumeEmployments();
    }
  }

  getResumeEmployments(){
    const resumeId = this.resumeId();
    if (!resumeId) {
      return;
    }
    this.resumeService.getResumeEmployments(resumeId).subscribe({
      next: res => {
        this.employments.set(res);
      }
    });
  }

  add() {
    this.indexResume.set(null);
    if (this.modalEmploymentComponent()) {
      this.modalEmploymentComponent()?.reset();
    }
  }

  editResumeEmployment(resumeEmployment: ResumeEmployment, index: number) {
    this.indexResume.set(index);
    if (this.modalEmploymentComponent()) {
      this.modalEmploymentComponent()?.form.patchValue({
        ...resumeEmployment as any,
        startDate: formatDate(resumeEmployment.startDate, 'yyyy-MM-dd', 'en'),
        endDate: resumeEmployment.endDate ? formatDate(resumeEmployment.endDate, 'yyyy-MM-dd', 'en') : null
      });
      this.modalEmploymentComponent()?.changeCurrentJob();
    }
  }

  deleteResumeEmployment(resumeEmployment: ResumeEmployment, index: number) {
    const resumeId = this.resumeId();
    const id = resumeEmployment.id ?? 0;

    if (!resumeId) {
      this.employments.update(value => value?.filter((employment, i) => i !== index));
      return;
    }

    Swal.fire({
      title: 'Eliminar',
      text: '¿Desea eliminar este registro?',
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: '#0d1174',
      cancelButtonColor: '#3a3a3a',
      confirmButtonText: 'Eliminar'
    }).then((resultmodal) => {
      if (resultmodal.isConfirmed) {
        this.resumeService.deleteResumeEmployment(id).subscribe({
          next: res => {
            this.employments.update(employments => employments.filter(employment => employment.id !== id));
          }, error: res => {
            Swal.fire({
              title: 'Error',
              text: 'Ocurrió un error al eliminar el registro.',
              icon: 'error',
              confirmButtonColor: '#d33'
            });
          }
        })
      }
    });
  }

  handlerResumeEmployment(resumeEmployment: ResumeEmployment) {
    const resumeId = this.resumeId();
    if(resumeId){
      this.getResumeEmployments();
      return;
    }
    if (this.indexResume() != null || resumeEmployment.id) {
      this.employments.update(value => value?.map((employment, i) => {
        if (i === this.indexResume() || employment.id === resumeEmployment.id) {
          return resumeEmployment
        }
        return employment;
      }));
      return;
    }
    this.employments.set([...this.employments(), resumeEmployment]);
  }
}